(function () {
  const grid = document.querySelector('.main-collection-product-list-d5');

  const setupButtons = (containerSelector, cssVar) => {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    const buttons = container.querySelectorAll('.per-row__button');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        grid.style.setProperty(cssVar, btn.dataset.perRow);
      });
    });
  };

  const syncAllActive = () => {
    const desktopContainer = document.querySelector('.per-row__wrapper.desktop');
    const mobileContainer = document.querySelector('.per-row__wrapper-mobile');

    if (desktopContainer) {
      const activeBtn = desktopContainer.querySelector('.per-row__button.active');
      if (activeBtn) grid.style.setProperty('--rows-count-d', activeBtn.dataset.perRow);
    }

    if (mobileContainer) {
      const activeBtn = mobileContainer.querySelector('.per-row__button.active');
      if (activeBtn) grid.style.setProperty('--rows-count-m', activeBtn.dataset.perRow);
    }
  };

  setupButtons('.per-row__wrapper.desktop', '--rows-count-d');
  setupButtons('.per-row__wrapper-mobile', '--rows-count-m');

  syncAllActive();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAllActive, 150);
  });
})();